import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DetailsFoldoutMixin extends Vue {
  private showDetails = false;

  get mainCard(): HTMLElement {
    const { mainCard } = this.$refs;

    if ((mainCard as Vue)?.$el) {
      return (mainCard as Vue)?.$el as HTMLElement;
    }

    return mainCard as HTMLElement;
  }

  get detailsCard(): HTMLElement {
    const { details } = this.$refs;

    if ((details as Vue)?.$el) {
      return (details as Vue)?.$el as HTMLElement;
    }

    return details as HTMLElement;
  }

  public async openDetails(): Promise<void> {
    if (!this.mainCard || !this.detailsCard || this.showDetails) {
      return;
    }

    this.showDetails = true;

    await this.$nextTick();

    this.setMainCardTransform();

    this.mainCard.ontransitionend = (e) => {
      if (e.propertyName !== 'transform') return;

      this.mainCard.style.transition = 'none';
      this.mainCard.style.transform = 'none';
      this.detailsCard.style.position = 'static';

      this.mainCard.ontransitionend = null;
    };
  }

  public hideDetails(): void {
    if (!this.mainCard || !this.showDetails) {
      return;
    }

    this.detailsCard.style.position = 'absolute';
    this.setMainCardTransform();

    window.requestAnimationFrame(() => {
      this.mainCard.style.transition = '0.4s';
      this.mainCard.style.transform = 'none';
      this.showDetails = false;
    });
  }

  private setMainCardTransform(): void {
    const detailsCardHeight = this.detailsCard.clientHeight;
    const distanceBetweenCards = 24;

    this.mainCard.style.transform = `translateY(${detailsCardHeight + distanceBetweenCards}px)`;
  }
}
